import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import ButtonSet from './ButtonSet';
import { colors, typography } from '../styles';
import PageSectionHeading from './PageSectionHeading';

const styles = css`
  padding:20px 0;
  @media (min-width: 480px) {
    padding:40px 0;
  }
  @media (min-width: 768px) {
    padding:60px 0;
  }

.row {
  /* flex-direction: column-reverse;
  @media (min-width: 1200px) {
    flex-direction: row;
    justify-content:center;
  } */
}
.formBanner__aside {
  width:100%;
  padding:0 15px;
  @media (min-width: 1199px) {
    width:450px;
    padding: 0 60px 0 15px;
  }
}
.formBanner__main {
  width:100%;
  padding:0 15px;
  @media (min-width: 1199px) {
    width:calc(100% - 450px);
    margin:0 auto;
  }
}
.formBanner__asideHeadline {
  font:700 18px/30px ${typography.SansSerif};
  color:${colors.brand4};
  text-transform:capitalize;
  @media (min-width: 480px) {
    font:700 24px/43px ${typography.SansSerif};
  }
}
.formBanner__asideBody, .formBanner__asideBody p {
  font:300 16px/24px ${typography.SansSerif};
  margin-bottom:15px;
}
`;

function FormBanner({ content, formArea }) {
  return (
    <div className="formBanner">
      <section className={styles}>
        {
          get(content, 'section_heading') &&
          <PageSectionHeading h3={get(content, 'section_heading')} />
        }
        <div className="container">
          <div className="row">
            {
              get(content, 'publish_sidebar') &&
              <aside className="formBanner__aside">
                {
                  (get(content, 'headline') || get(content, 'body')) &&
                  <div className="formBanner__asideWrapper">
                    {
                      get(content, 'headline') &&
                      <h2 className="formBanner__asideHeadline">{get(content, 'headline')}</h2>
                    }
                    {
                      get(content, 'body') &&
                      <div className="formBanner__asideBody" dangerouslySetInnerHTML={SanitizeHtml(get(content, 'body', ''))} />
                    }
                    <ButtonSet buttonSetParent={content} />
                  </div>
                }
              </aside>
              }
            <main className="formBanner__main">
              {formArea}
            </main>
          </div>
        </div>
      </section>
    </div>
  );
}

FormBanner.propTypes = {
  content: PropTypes.object,
  formArea: PropTypes.node.isRequired,
};

FormBanner.defaultProps = {
  content: undefined,
};

export default FormBanner;



// WEBPACK FOOTER //
// ./src/components/FormBanner.js